import { inject, Injectable } from '@angular/core';
import { catchError, lastValueFrom, mergeMap, Observable, of, throwError } from 'rxjs';
import { ApiService } from '../api/api.service';
import { API_ROUTE_GET_BERATER, API_ROUTE_SEARCH_BERATER, getApiUrl } from '../../app.constants';
import { IBerater, ISearchKundenberaterRequest } from '../../model/berater-http.model';
import { IkpPopupService } from '@shared/service/popup/popup.service';

@Injectable({
  providedIn: 'root',
})
export class BeraterService extends ApiService {
  private readonly popupService = inject(IkpPopupService);

  loadAllBerater(): Observable<IBerater[]> {
    return this.httpClient.post<IBerater[]>(getApiUrl(this.apiUrl, API_ROUTE_SEARCH_BERATER), {}).pipe(
      catchError(error => {
        this.handleErrorBeraterLoad();
        throw error;
      }),
    );
  }
  loadBerater(requestBody: ISearchKundenberaterRequest): Observable<IBerater[]> {
    return this.httpClient.post<IBerater[]>(getApiUrl(this.apiUrl, API_ROUTE_SEARCH_BERATER), requestBody).pipe(
      catchError(error => {
        this.handleErrorBeraterLoad();
        throw error;
      }),
    );
  }

  getBeraterInfoAboutCurrentUser(): Promise<IBerater> {
    return lastValueFrom(
      this.httpClient.get<IBerater>(getApiUrl(this.apiUrl, API_ROUTE_GET_BERATER), { observe: 'response' }).pipe(
        mergeMap(response => {
          if (response && response.status !== 200) {
            return throwError(() => new Error('Get berater request failed.'));
          } else {
            return of(response.body);
          }
        }),
      ),
    );
  }

  private handleErrorBeraterLoad(): void {
    this.popupService.handleErrorPopup('search-berater-error', 'global.errors.berater.title');
  }
}
